import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class QueryEngineService {

  constructor(private apiService: ApiService) { }

  getQueryList(): Promise<any> {
    const promise = new Promise<any>((resolve, reject) => {
      this.apiService.get('queryEngine/getQueryList/', null)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  getQueryResult(model: any): Promise<any> {
    const params = {
      queryId: model.queryId,
      reportPackId: model.reportPackId,
      pageNumber: model.pageNumber,
      pageSize: model.pageSize,
      isInitialLoad: model.isInitialLoad,
      sortList: model.sortList,
      filter: model.filter,
      auditReportDetailDesc: model?.auditReportDetailDesc,
      queryTypeId: model?.queryTypeId
    };
    const promise = new Promise<any>((resolve, reject) => {
      this.apiService.post('queryEngine/getQueryResult/', params, '')
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  downloadQueryResult(model: any) {
    
    const params = {
      queryId: model.queryId,
      reportPackId: model.reportPackId,
      pageNumber: model.pageNumber,
      pageSize: model.pageSize,
      isInitialLoad: model.isInitialLoad,
      sortList: model.sortList,
      filter: model.filter,
      queryDisplayName: model.queryDisplayName.slice(0, 29),
      reportPackTitle: model.reportPackTitle.replace(/[^a-zA-Z0-9]/g, ''),
      auditReportDetailDesc: model?.auditReportDetailDesc,
      queryTypeId: model?.queryTypeId
    };
    const promise = new Promise((resolve, reject) => {
      this.apiService.postwithFile('queryEngine/downloadQueryResult/', params, 'application/json')
        .toPromise()
        .then(
          res => { // Success
            this.downloadFile(res)
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  downloadFile(data: any) {
    let blob = data.body;
    const contentHeader = data.headers.get('content-disposition');
    if (contentHeader !== null && blob !== null) {
      let fileName = data.headers.get('content-disposition').split(';')[1].trim().split('=')[1].replace(/"/g, '');
      saveAs(blob, fileName);
    }
  }

   saveUserDefinedQueries(model) {
    const params = {
      queryId: model.queryId,
      queryTypeId: model?.queryTypeId,
      reportPackId: model.reportPackId,
      sortList: model.sortList,
      filter: model.filter,
      auditReportDetailDesc: model?.auditReportDetailDesc,
      queryName: model?.queryName,
      comments: model?.comments,
    };
    const promise = new Promise((resolve, reject) => {
      this.apiService.post('queryEngine/SaveUserDefinedQueries/', params, '')
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

  getUserDefinedQueries(): Promise<any> {
   const promise = new Promise<any>((resolve, reject) => {
      this.apiService.get('queryEngine/getUserDefinedQueries/', null)
        .toPromise()
        .then(
          res => { // Success
            resolve(res);
          },
          msg => { // Error
            reject(msg);
          }
        );
    });
    return promise;
  }

}
